import _ from '../../core/utils'
const productsConfig = {
    section: _.select( '.section--default-products-grid' )
}
export default productsConfig